// Actions
export const ORDER_SERVICES__GET_SERVICES = 'ORDER_SERVICES__GET_SERVICES';
export const ORDER_SERVICES__SUBMIT_QUOTE = 'ORDER_SERVICES__SUBMIT_QUOTE';
export const ORDER_SERVICES__SUBMIT_PRICED_LTRS_SERVICE =
  'ORDER_SERVICES__SUBMIT_PRICED_LTRS_SERVICE';
// Getters
export const ORDER_SERVICES__AVAILABLE_SERVICES = 'ORDER_SERVICES__AVAILABLE_SERVICES';
export const ORDER_SERVICES__SELECTED_SERVICE = 'ORDER_SERVICES__SELECTED_SERVICE';
// Mutations
export const ORDER_SERVICES__RESET = 'ORDER_SERVICES__RESET';
export const ORDER_SERVICES__MUTATE_LOADING_STATUS = 'ORDER_SERVICES__MUTATE_LOADING_STATUS';
export const ORDER_SERVICES__MUTATE_SERVICES = 'ORDER_SERVICES__MUTATE_SERVICES';
